/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_CareInputs */

const en_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const ar_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#رعاية`)
};

const bn_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const de_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const es_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const fr_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const pt_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const zh_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const tr_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const ru_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

const pl_svtag_care = /** @type {(inputs: Svtag_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CARE`)
};

/**
* | output |
* | --- |
* | "#CARE" |
*
* @param {Svtag_CareInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_care = /** @type {((inputs?: Svtag_CareInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_CareInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_care(inputs)
	if (locale === "bn") return bn_svtag_care(inputs)
	if (locale === "de") return de_svtag_care(inputs)
	if (locale === "es") return es_svtag_care(inputs)
	if (locale === "fr") return fr_svtag_care(inputs)
	if (locale === "pt") return pt_svtag_care(inputs)
	if (locale === "zh") return zh_svtag_care(inputs)
	if (locale === "tr") return tr_svtag_care(inputs)
	if (locale === "ru") return ru_svtag_care(inputs)
	if (locale === "pl") return pl_svtag_care(inputs)
	return en_svtag_care(inputs)
});